// src/Pages/VendorInstructions.js
import React from "react";
import { Link } from "react-router-dom";
import "./FAQ.css";
import registerVendorImg from "../../assets/register-vendor.png"
import createVendorImg from "../../assets/create-vendor.png"


export default function VendorInstructions() {
  return (
    <div className="faq-container">
      <h2 className="faq-heading">Vendor Instructions</h2>
      <p className="faq-text">
        Creating a Vendor profile on <strong>itiniri</strong> is simple and
        completely free!
      </p>
      <p className="faq-text">
        Create and manage your vendor profile for an event:
      </p>
      <ol className="faq-steps">
        <li className="faq-step-item">Create an account at itiniri.app/auth</li>
        <li className="faq-step-item">
          Click <strong>Register a New Vendor Profile</strong> section in your
          dashboard.
        </li>
        <img src={registerVendorImg} alt="Descriptive text" className="faq-image"/>

        <li className="faq-step-item">
          Enter your basic information.
        </li>
        <li className="faq-step-item">
          If you have recieved a <strong>Gathering Reference ID</strong> from an
          Event, enter it here to link your profile to the Event.
        </li>
        <li className="faq-step-item">
          Click <strong>Register</strong> to create your profile.
        </li>
        <img src={createVendorImg} alt="Descriptive text" className="faq-image"/>

        <li className="faq-step-item">
          In your Vendor Dashboard, you can update your information, upload your
          profile image, and add several links to your social media or website.
        </li>
        <li className="faq-step-item">
          Make sure to click <strong>Save Changes</strong> to save your updates.
          All information made in your Artist Dashboard will be shown in the
          app.
        </li>
      </ol>
      <Link to="/faq" className="faq-back-link">
        ← Back to FAQ
      </Link>
    </div>
  );
}
